(function () {
    document.querySelectorAll('.wp-block-pulp-tabs-with-chart .tabs').forEach(function (tabsEl) {
        const tabs   = Array.from(tabsEl.querySelectorAll('[role="tab"]'));
        const panels = Array.from(tabsEl.querySelectorAll('[role="tabpanel"]'));

        function activate(tab) {
            tabs.forEach(function (t) {
                const isActive = t === tab;
                t.setAttribute('aria-selected', String(isActive));
                t.tabIndex = isActive ? 0 : -1;
            });
            panels.forEach(function (p) {
                p.hidden = p.id !== tab.getAttribute('aria-controls');
            });
            tab.focus();
        }

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () { activate(tab); });
            tab.addEventListener('keydown', function (e) {
                const idx = tabs.indexOf(e.currentTarget);
                if (e.key === 'ArrowRight')     activate(tabs[(idx + 1) % tabs.length]);
                else if (e.key === 'ArrowLeft') activate(tabs[(idx - 1 + tabs.length) % tabs.length]);
                else if (e.key === 'Home')      activate(tabs[0]);
                else if (e.key === 'End')       activate(tabs[tabs.length - 1]);
            });
        });
    });
})();
